import { GridItem, Text } from '@chakra-ui/react';
import { Field } from '@/components';
import { showSuccess } from '@/utils';

interface IProps {
  span?: number | 'auto';
  label: string;
  disabled?: boolean;
  width?: string | number;
  value?: string;
  className?: string;
  horizontal?: boolean;
  showTooltip?: boolean;
  canCopy?: boolean;
  border?: string;
  color?: string;
}

function BaseTextField(props: IProps) {
  const gridProps: any = {
    colSpan: props.span || 'auto',
  };
  if (props.width) gridProps.width = props.width;

  function handleCopy() {
    navigator.clipboard.writeText(props.value || '');

    showSuccess('Copied');
  }

  return (
    <GridItem {...gridProps}>
      <Field
        label={props.label}
        className={`${props.horizontal ? 'input-h' : ''} ${props.className}`}
      >
        <Text
          borderRadius="15px"
          border={props.border ?? '1px solid #E2E8F0'}
          fontSize="14px"
          height="40px"
          lineHeight="40px"
          fontWeight="400"
          width="full"
          padding="0px 14px"
          title={props.showTooltip ? props.value : undefined}
          cursor={props.canCopy ? 'pointer' : 'default'}
          onClick={props.canCopy ? handleCopy : undefined}
          color={props.color ?? '#09090B'}
          pos="relative"
        >
          {props.value}
          {props.canCopy && (
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 448 512"
              height="16px"
              width="16px"
              xmlns="http://www.w3.org/2000/svg"
              style={{ position: 'absolute', right: 1, zIndex: 1, top: 12, color: '#555' }}
            >
              <path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"></path>
            </svg>
          )}
        </Text>
      </Field>
    </GridItem>
  );
}

export { BaseTextField };
